import React, { useState, useEffect, useRef } from "react";
import { Link } from "react-router-dom";
import { useMyContext } from "../../../components/Provider/CommonProvider";
import { toast } from "react-toastify";
import Response_Processing from "../../../layout/Others/Response_Processing";
import AdminDeleteModal from "../../../components/CommonComponents/AdminDeleteModal";
import AdminSliderModal from "../../../components/CommonComponents/AdminSliderModal";
import AdminNavbar from "../../../components/CommonComponents/AdminNavbar";
import { FaEllipsisVertical } from "react-icons/fa6";
import MessageBox from "../../../components/CommonComponents/MessageBox";
import { DragDropContext, Droppable, Draggable } from "react-beautiful-dnd";
import NoRecordTable from "../../../components/CommonComponents/NoRecordTable";
import AdminSwitch from "../../../components/CommonComponents/AdminSwitch";
import MessageLabel from "../../../components/CommonComponents/MessageLabel";
import MessageSubHeading from "../../../components/CommonComponents/MessageSubHeading";
import { RxReload } from "react-icons/rx";
import ExportIcon from "../../../components/Images/icons/Export_Icon_01.png";
import { donwloadCSV, downloadPDF, downloadXLSX } from "../../../components/CommonMethod/CommonMethods";
import { IoClose } from 'react-icons/io5';
import { IconDeleteFigma, IconEditFigma } from "../../../Assets/MyIcons";
import AdminTooltip from "../../../components/CommonComponents/AdminTooltip";
import AdminCustomButton from "../../../components/CommonComponents/AdminCustomButton";
import AdminCustomInput from "../../../components/CommonComponents/AdminCustomInput";
import { BiCheck, BiX } from "react-icons/bi";
import SubFooterMenuModal from "./SubFooterMenuModal";
import SubFooterLogoModal from "./SubFooterLogoModal";

function FooterMenu() {
  const baseURL = process.env.REACT_APP_Baseurl

  const indexApi = `${baseURL}/admin/footer_menu/index`
  const deleteApi = `${baseURL}/admin/footer_menu/multi-delete`
  const suffleApi = `${baseURL}/admin/footer_menu/ordering`
  const activeApi = `${baseURL}/admin/active-footer-menu`
  const indexColumnApi = `${baseURL}/admin/footer_menu/column-index`
  const updateColumnApi = `${baseURL}/admin/footer_menu/column-update`

  const { fetchRequest } = useMyContext()
  const [withOutRefresh, setWithOutRefresh] = useState(false)
  const [apiData, setApiData] = useState();
  const [showOverlay, setShowOverlay] = useState(false);
  const [loading, setLoading] = useState(true)
  const [modalClose, setModelClose] = useState(false)
  const [selectAllData, setSelectAllData] = useState(false);
  const [itemDelete, setItemDelete] = useState([])
  const [showModal, setShowModal] = useState(false);
  const [currentItem, setCurrentItem] = useState(null);
  const [filter, setFilter] = useState('');
  const [filteredData, setFilteredData] = useState();
  const [formData, setFormData] = useState({
    state: "formData",
    view_type: "list",
    view_type_option: [{
      name: "List",
      value: "list"
    },
    {
      name: "Gallery",
      value: "grid"
    }]
  });
  const [modifiedColumns, setModifiedColumns] = useState({});

  const [columnData, setColumnData] = useState([]);
  const [showColumns, setShowColumns] = useState(false);
  const [showSubFooterModal, setShowSubFooterModal] = useState(false);
  const [showSubFooterLogoModal, setShowSubFooterLogoModal] = useState(false);
  const [editingColumn, setEditingColumn] = useState(null);
  const [editValue, setEditValue] = useState('');
  const inputRef = useRef(null);

  const handleDelete = async () => {
    setShowOverlay(true);
    handleCloseModal()
    try {
      const response = await fetchRequest({
        method: 'DELETE',
        url: `${deleteApi}`,
        params: {},
        data: { id: [...itemDelete] },
      })

      const result = response;
      if (result?.status) {
        toast.success(result?.message)
        setWithOutRefresh(!withOutRefresh)
        setSelectAllData(false)
      }
    }
    catch (err) {
      const errMessage = err?.response?.data?.message
      toast.error(errMessage)
    }
    finally {
      setLoading(false)
      setShowOverlay(false);
    }
  }
  const saveShuffleOrder = async (updatedItems) => {
    setShowOverlay(true);

    if (!updatedItems || updatedItems?.length === 0) {
      toast.error("Menu items are empty");
      return;
    }
    else {
      const ids = updatedItems?.map((menuItem) => menuItem?.id);
      const positions = updatedItems?.map((_, index) => index + 1);
      const requestData = {
        id: ids,
        position: positions,
      };
      try {
        const response = await fetchRequest({
          method: 'PATCH',
          url: `${suffleApi}`,
          params: {},
          data: requestData,
        })
        const result = response;
        if (result?.status) {
          toast.success(result?.message)
          setWithOutRefresh(!withOutRefresh)
          setShowOverlay(false);
        }
        else {
          setShowOverlay(false)
          toast.error(result?.message)
        }
      } catch (err) {
        setShowOverlay(false)
        console.error(err);
        var errorMessage = err?.response?.data?.message;
        toast.error(errorMessage)
      }
    }
  };

  const handleDragEnd = (result) => {
    if (!result.destination) return;
    const reorderedItems = Array.from(apiData);
    const [movedItem] = reorderedItems?.splice(result.source.index, 1);
    reorderedItems?.splice(result.destination.index, 0, movedItem);
    setApiData(reorderedItems);
    saveShuffleOrder(reorderedItems);
  };

  const handleSelectAllData = () => {
    setSelectAllData(!selectAllData);
    setItemDelete(selectAllData ? [] : apiData?.map((item) => item?.id));
  };

  const handleSingleFile = (itemId) => {
    if (itemDelete?.includes(itemId)) {
      setItemDelete(
        itemDelete?.filter((id) => id !== itemId)
      );
    } else {
      setItemDelete([...itemDelete, itemId]);
    }
  };

  const handleCloseModal = () => {
    setShowColumns(false);
    setModelClose(!modalClose)
    setItemDelete([]);
  }

  const handleCloseColumnsModal = () => {
    setShowColumns(false);
  }

  const handleOpenDeleteModal = async () => {
    setModelClose(true)
  }

  const confirmToggle = async () => {
    setShowOverlay(true);
    setShowModal(false);
    try {
      const newStatus = currentItem?.active === 1 ? 0 : 1;

      const formData = {
        menu_id: currentItem?.id,
        active: newStatus,
      };

      const response = await fetchRequest({
        method: 'POST',
        url: `${activeApi}`,
        params: {},
        data: formData,
      })
      const result = response
      if (result.status) {
        setWithOutRefresh(!withOutRefresh);
        toast.success(result?.message);
        setShowOverlay(false);
        setCurrentItem(null);
      }
      else {
        toast.error(result?.message);
        setShowOverlay(false);
      }
    } catch (err) {
      var errorMessage = err?.response?.data?.message;
      toast.error(errorMessage);
      setShowOverlay(false);
    }
  };

  const handleValidation = () => {
    // Check if at least one column has content
    const hasContent = columnData.some(col => col.column_name.trim().length > 0);
    if (!hasContent) {
      toast.warning("Please fill at least one column to save");
      return false;
    }

    // Check character limits
    const exceedsLength = columnData.some(col => col.column_name.length > 25);
    if (exceedsLength) {
      toast.warning("Column names should not exceed 25 characters");
      return false;
    }

    const filledColumns = columnData.filter(col => col.column_name.trim().length > 0);
    const uniqueNames = new Set(filledColumns.map(col => col.column_name.toLowerCase()));

    if (uniqueNames.size !== filledColumns.length) {
      toast.warning("Column names should be unique");
      return false;
    }

    const missingRequired = columnData.some(col => !col.column_name.trim());
    if (missingRequired) {
      toast.warning("All columns must be filled");
      return false;
    }

    return true;
  };

  const handleToggle = async (e, item) => {
    setCurrentItem(item);
    setShowModal(true);
  };

  const closeModal = () => {
    setModelClose(!closeModal);
    setShowModal(false);
    setItemDelete([]);
  };

  const singleDelete = (id) => {
    setModelClose(true);
    setItemDelete([id]);
  };
  const handleInput = (e) => {
    const { type, name, value, checked } = e.target
    if (type === "search") {
      setFormData((prev) => ({
        ...prev,
        [name]: value,
      }))
    }
    if (type === "text") {
      setColumnData((prev) => ({
        ...prev,
        [name]: value || "",
      }));
    }
  }

  const handleInputColumn = (e, columnId) => {
    const { value } = e.target;
    setColumnData(prev => {
      if (prev.some(c => c.id === columnId)) {
        return prev.map(c =>
          c.id === columnId ? { ...c, column_name: value } : c
        );
      }
      return [...prev, { id: columnId, column_name: value }];
    });

    setModifiedColumns(prev => ({
      ...prev,
      [columnId]: value
    }));
    console.log("Updated columnData:", columnData);
  }

  const handleAddColumns = () => {
    setShowColumns(true);
  }

  const [currentPage, setCurrentPage] = useState(1);
  const [perPage, setPerPage] = useState(10);

  const totalPages = Math.ceil(apiData?.length / perPage);
  const paginatedData = apiData?.slice((currentPage - 1) * perPage, currentPage * perPage);
  const reloadAction = () => {
    setWithOutRefresh(prev => !prev)
  }

  const handleFilter = (event) => {
    const searchTerm = event.target.value.toLowerCase();
    setFilter(searchTerm);

    if (searchTerm.trim() === '') {
      setFilteredData(apiData); // ✅ show full data when empty
      return;
    }
    const filteredResults = apiData?.filter((item) =>
      ["id", "name", "column_position", "active", "select_url", "custom_url", "order", "link"].some((property) => {
        const value = item[property];
        if (property === "column_position" && value) {
          return `column ${value}`.toLowerCase().includes(searchTerm);
        }
        return typeof value === "string" && value.toLowerCase().includes(searchTerm);
      }) ||
      (typeof item.id === "number" && item.id.toString().includes(searchTerm))
    );
    setFilteredData(filteredResults);
  };

  const handleClear = () => {
    setFilter('');
    setFilteredData(apiData); // Reset to full list
  };
  const fetchData = async (type) => {
    setShowOverlay(true);
    setLoading(true);
    try {
      const response = await fetchRequest({
        method: 'GET',
        url: `${indexApi}`,
        params: {},
        data: {},
      });

      if (response?.status) {
        const updatedList = response?.data;
        setApiData(updatedList);
        setFilteredData(updatedList);
        if (type === "CSV") {
          await donwloadCSV(updatedList, "FOOTER-MENU-LIST");
        }
        if (type === "PDF") {
          await downloadPDF(updatedList, "FOOTER-MENU-LIST", ["INDEX", "ID", "NAME"]);
        }
        if (type === "XLSX") {
          await downloadXLSX(updatedList, "FOOTER-MENU-LIST", ["INDEX", "ID", "NAME"]);
        }
      }
    } catch (error) {
      toast.error(error?.response?.data?.message);
    } finally {
      setShowOverlay(false);
      setLoading(false);
    }
  };

  const fetchColumnData = async () => {
    try {
      const response = await fetchRequest({
        method: 'GET',
        url: `${indexColumnApi}`,
        params: {},
        data: {},
      });
      if (response?.status) {
        const apiColumns = response?.footerMenuColumn || [];
        setColumnData(apiColumns);
      }
    } catch (error) {
      toast.error(error?.response?.message);
    }
  };

  const handleSaveColumn = async (columnId) => {
    if (!editValue.trim()) {
      toast.warning("Column name cannot be empty");
      return;
    }

    if (editValue.length > 25) {
      toast.warning("Column name should not exceed 25 characters");
      return;
    }

    setShowOverlay(true);
    try {
      const response = await fetchRequest({
        method: 'PATCH',
        url: `${updateColumnApi}/${columnId}`,
        data: { column_name: editValue }
      });

      if (response?.status) {
        toast.success("Column updated successfully");
        setEditingColumn(null);
        fetchColumnData();
      } else {
        toast.error(response?.message || "Update failed");
      }
    } catch (error) {
      toast.error(error?.response?.data?.message || "Update failed");
    } finally {
      setShowOverlay(false);
    }
  };

  const handleEditColumn = (column) => {
    setEditingColumn(column.id);
    setEditValue(column.column_name);
    setTimeout(() => inputRef.current?.focus(), 0);
  };

  const handleCancelEdit = () => {
    setEditingColumn(null);
    setEditValue('');
  };

  const renderColumnInput = (column) => {
    if (editingColumn === column.id) {
      return (
        <div className="position-relative col-8">
          <AdminCustomInput
            ref={inputRef}
            id={`footer-column${column.id}`}
            name={`column${column.id}`}
            value={editValue}
            onChange={(e) => setEditValue(e.target.value)}
            placeholder={`Enter Column ${column.id} Name`}
          />
          <div className="actionTable position-absolute" style={{ right: 0, top: '35%', transform: 'translateY(-50%)' }}>
            <button
              type="button"
              className="bg-transparent border-0"
              onClick={() => handleSaveColumn(column.id)}
            >
              <BiCheck className="save-icon theme-text-color" />
            </button>
            <button
              type="button"
              className="bg-transparent border-0"
              onClick={handleCancelEdit}
            >
              <BiX className="save-icon theme-text-color" />
            </button>
          </div>
        </div>
      );
    }
    return (
      <div
        onClick={() => handleEditColumn(column)}
        className="d-flex position-relative "
        style={{
          cursor: 'pointer',
          padding: '8px',
          border: '1px solid transparent',
          borderRadius: '4px',
          minHeight: '35px',
          lineHeight: '5px'
        }}
      >
        {column.column_name || "Empty"}
      </div>
    );
  };

  useEffect(() => {
    fetchData();
    fetchColumnData();
  }, [withOutRefresh]);

  return (
    <>
      {/* {showOverlay && <Response_Processing />} */}
      <SubFooterMenuModal show={showSubFooterModal} handleClose={() => setShowSubFooterModal(false)} />
      <SubFooterLogoModal show={showSubFooterLogoModal} handleClose={() => setShowSubFooterLogoModal(false)} />
      {modalClose && <AdminDeleteModal modelClose={modalClose} deleteClose={closeModal} deleteAction={handleDelete} buttonText={itemDelete?.length} />}
      {showModal ? <AdminSliderModal modalDescription={`Do you want to  ${currentItem?.active == 1 ? 'disable' : 'enable'} this footer menu ?`} modalHeading={"Menu Status"} modelClose={showModal} sliderClose={closeModal} sliderAction={confirmToggle} buttonText={currentItem?.active} /> : ""}
      <div className="">
        <div className="col-12 ">
          <AdminNavbar heading={'All Footer Menus'} totalDataLength={apiData?.length} deleteCount={itemDelete?.length} navigation={'/addfootermenu'} deleteMethod={handleOpenDeleteModal} navText={'Add Footer Menu'} footerColumn={false} />
        </div>
        <div className="col-12 d-flex pb-3 justify-content-end">
          <AdminCustomButton className="ms-3" saveText={"Columns"} saveMethod={handleAddColumns} id="footerColumn" />
          <AdminCustomButton className="ms-3" saveText={"Sub Footer"} saveMethod={() => setShowSubFooterModal(true)} />
          <AdminCustomButton className="ms-3" saveText={"Sub Footer Logo"} saveMethod={() => setShowSubFooterLogoModal(true)} />
        </div>
      </div>

      <div className={`modal packageModel fade ${showColumns ? 'd-block show' : ""}`} id="exampleModal" tabIndex="-1" role="dialog" aria-labelledby="exampleModalLabel" aria-hidden="true">
        <div className="modal-dialog theme-bg-color rounded-3" role="document">
          <div className="modal-content theme-bg-color">
            <div className="modal-header theme-border-bottom-secondary">
              <h5 className="modal-title theme-text-color">{"Footer Columns"}</h5>
              <button type="button" className='bg-transparent theme-text-color' onClick={() => handleCloseColumnsModal()} >
                <IoClose fill='currentColor' style={{ width: "25px", height: "25px" }} />
              </button>
            </div>
            <div className="modal-body">
              {columnData.map(column => (
                <div key={column.id} className="mb-3 col-12 d-flex align-items-center justify-content-start">
                  <div className="col-4">
                    <MessageLabel text={`Column ${column.id}`} className="mandatorySimple" />
                  </div>
                  {renderColumnInput(column)}
                </div>
              ))}
            </div>
            <div className="modal-footer border-0">
              <AdminCustomButton saveMethod={() => setShowColumns(false)} saveText={"Close"} className="m-0" />
            </div>
          </div>
        </div>
      </div>

      <div className="bootstrapTable theme-bg-color p-3 rounded-2">
        <div className="">
          <div className='d-flex align-items-center flex-wrap justify-content-between mb-3'>
            <div className="filterContainer">
              <input type='text' placeholder="Search" className="filter form-control theme-text-color theme-border-secondary" value={filter} onChange={(event) => handleFilter(event)} />
              {filter?.length > 0 && (<button type="button" className="clearBtn" onClick={() => handleClear()}  ><IoClose className="custom-close-btn" /> </button>)}
            </div>
            <div className='d-flex align-items-center'>
              <button id="reloadButton" onClick={reloadAction} className={`custom-tool-tip-parent bg-transparent reloadButton theme-text-color p-2 me-2 primary border border-2 rounded-circle theme-border-color `} >
                <RxReload style={{ width: "18px", height: "15px" }} className={`${loading ? "rotate-load" : ""}`} />
                <AdminTooltip text="Refresh" top={"-41px"} className="d-none custom-tool-tip" />
              </button>

              <div className="dropdown d-block ms-2 " key={"2"}>
                <button className="btn btn-success dropdown-toggle d-flex hideArrow" type="button" id="exportAllButton" data-bs-toggle="dropdown" aria-expanded="false"  >
                  <span className="fw-bolder text-white">Export All</span>
                  <img src={ExportIcon} className="ms-2 exportIcon" alt="exportIcon" />
                </button>
                <ul className="dropdown-menu theme-bg-color" aria-labelledby="exportAllButton" >
                  <li id="exportallCSV" className="dropdown-item theme-text-color" >CSV</li>
                  <li id="exportallPDF" className="dropdown-item theme-text-color" >PDF</li>
                  <li id="exportallXLSX" className="dropdown-item theme-text-color" >XLSX </li>
                </ul>
              </div>
            </div>
          </div>
          <div className="d-flex flex-wrap theme-border-bottom-secondary pb-3">
            <div className="rowCheckboxfooterDrag col-2 p-2"> <label><input type="checkbox" checked={selectAllData} onChange={handleSelectAllData} /> </label></div>
            <div className="col-3 p-2 "> <label className="theme-text-color fw-bold fs-6">Footer Menu </label> </div>
            <div className="col-2 p-2 "><label className="theme-text-color fw-bold fs-6">Column Position</label></div>
            <div className="col-2 p-2 "><label className="theme-text-color fw-bold fs-6">Status</label></div>
            <div className="col-3 p-2">
              <label className="theme-text-color fw-bold fs-6">Actions</label>
            </div>
          </div>
        </div>
      </div>
      <DragDropContext onDragEnd={handleDragEnd}>
        <Droppable droppableId="menu-items" className="theme-bg-color"   >
          {(provided) => (
            <ul  {...provided.droppableProps} ref={provided.innerRef} className="pb-5 px-0 theme-bg-color m-0 p-0 list-unstyled">
              {loading ? <NoRecordTable result={filteredData?.length} loader={true} /> :
                filteredData?.length ? filteredData?.map((item, index) => (
                  <Draggable key={item?.id.toString()} draggableId={item?.id.toString()} index={index} >
                    {(provided) => (
                      <li ref={provided.innerRef} {...provided.draggableProps} {...provided.dragHandleProps} className={` theme-bg-color theme-text-color   ${item.order} index ${index + 1} w-100 px-3 py-2 theme-border-bottom-secondary`} >
                        <div className="d-flex flex-wrap align-items-center">

                          <div className="rowCheckboxfooterDrag category-order-title col-2">
                            <input
                              type="checkbox"
                              checked={itemDelete?.includes(item.id)}
                              onChange={() => handleSingleFile(item.id)}
                            />
                          </div>

                          <div className="col-3  category-order-title">
                            <div className="d-flex justify-content-between align-items-center ">
                              <div className="rightVideoTitle d-flex flex-column ">
                                <MessageBox text={item?.name} classname="admin-input-title" loadingHide />
                                <span className="dateText table-subheading "> {item?.upload_on}</span>
                              </div>
                            </div>
                          </div>
                          <div className="col-2  category-order-title">
                            <MessageBox text={item?.column_name} noMargin loadingHide />
                          </div>
                          <div className="col-2  category-order-title">
                            <AdminSwitch name="active" checked={item?.active == 1} onChange={(e) => handleToggle(e, item)} id={item?.id} />
                          </div>
                          <div className="col-3">
                            <div className="editdropdown">
                              <span className="editdropdown-button">
                                <FaEllipsisVertical className="theme-text-color" />
                              </span>
                              <div className="editdropdown-menu theme-bg-color">
                                <Link to={`/editfootermenu/${item?.id}`} className="theme-text-color theme-bg-color">
                                  <IconEditFigma styled={{ width: "20px", height: "20px" }} />
                                  <MessageBox text="Edit" classname='ms-2 theme-text-color' />
                                </Link>
                                <div onClick={() => singleDelete(item?.id)} className="commonActionPadding theme-bg-color">
                                  <IconDeleteFigma styled={{ width: "20px", height: "20px" }} />
                                  <MessageBox text="Delete" classname='ms-2 theme-text-color' />
                                </div>
                              </div>
                            </div>
                          </div>
                        </div>
                      </li>
                    )}
                  </Draggable>
                )) : <NoRecordTable result={apiData?.length} loader={false} />}
            </ul>
          )}
        </Droppable>
      </DragDropContext>
    </>
  );
}
export default FooterMenu;